import { _ as _objectSpread2 } from '../../dist/objectSpread2-811c5212.esm.js';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import { createContext, useContext } from 'react';
import { useTracking } from '../../context/selectors/dist/uswitch-ev-utils-context-selectors.esm.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../../obj/dist/uswitch-ev-utils-obj.esm.js';
import '@babel/runtime/helpers/defineProperty';
import '../../nil/dist/uswitch-ev-utils-nil.esm.js';
import '../../contentful/dist/uswitch-ev-utils-contentful.esm.js';
import '../../context/provider/dist/uswitch-ev-utils-context-provider.esm.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import '../../conditional-wrapper/dist/uswitch-ev-utils-conditional-wrapper.esm.js';
import 'react-chansey';
import 'react-chansey/lib/provider';
import '../../helpers/env/dist/uswitch-ev-utils-helpers-env.esm.js';
import 'theme-ui/jsx-runtime';

var ComponentTrackingContext = /*#__PURE__*/createContext(function () {
  console.warn("You shouldn't reach here");
});
var useComponentTracking = function useComponentTracking() {
  return useContext(ComponentTrackingContext);
};
var useTrackModule = function useTrackModule(props) {
  var _props$sys = props.sys,
    sys = _props$sys === void 0 ? {} : _props$sys,
    name = props.name,
    variant = props.variant,
    moduleIndex = props.moduleIndex,
    layout = props.layout;
  var id = sys.id,
    type = sys.contentTypeId;
  var track = useTracking();
  var trackProps = {
    component_category: 'eevee-component',
    component_id: id,
    // type of module i.e. imageCalloutModule
    component_name: type,
    contentful_name: name,
    contentful_variant: variant,
    contentful_layout: layout,
    module_position_on_page: moduleIndex
  };
  var trackComponent = function trackComponent(eventGrouping, eventName, eventData) {
    var additionalTrackProps = {
      event_name: eventName
    };
    if (eventData) {
      for (var key in eventData) {
        if (_typeof(eventData[key]) === 'object') {
          console.warn('Please do not nest objects in eventData as it is difficult to parse');
        }
      }
      additionalTrackProps.event_data = JSON.stringify(eventData);
    }
    return track(eventGrouping, _objectSpread2(_objectSpread2({}, trackProps), additionalTrackProps));
  };
  return {
    trackComponent: trackComponent,
    trackProps: trackProps
  };
};

/**
 * timeout
 *
 * Used when we want to wait for a tracking event to resolve,
 * and we don't want to block what happens after
 *
 * @param {Promise} p - promise which should resolve
 * @param {number} [ms] - (optional) number of ms before promise resolves
 * @returns {Promise} - which will resolve after a timeout
 */
var timeout = function timeout(p) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  return Promise.race([willResolve(ms), p]);
};
function willResolve(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

export { ComponentTrackingContext, timeout, useComponentTracking, useTrackModule };
